import type { Project } from '@vd/types';

/**
 * What a project's numbers count (TOADO-943). The sidebar shows open tickets,
 * what is left to do; done and archived are given beside them on hover and on
 * All projects. A server older than the split sends only `ticketCount`, which
 * is then shown as it always was.
 */
type Counted = Pick<Project, 'ticketCount' | 'openCount' | 'doneCount' | 'archivedCount'>;

export function openTickets(project: Counted): number {
  return project.openCount ?? project.ticketCount;
}

export function projectCountsLine(project: Counted): string {
  if (project.openCount === undefined) return `${project.ticketCount} tickets`;
  return `${project.openCount} open · ${project.doneCount ?? 0} done · ${project.archivedCount ?? 0} archived`;
}
